import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination as HeroPagination } from '@heroui/react';
export const Pagination = (props) => {
    return _jsx(HeroPagination, { ...props });
};
export default Pagination;
//# sourceMappingURL=Pagination.js.map